class StickyHeader extends HTMLElement {
  constructor() {
    super()

    this.selectors = {
      navMobileButton: '[data-nav-button]',
      navMobileButtonClose: '[ data-nav-button-close]',
      promoBarSlider: '[data-msgs-slider]',
      navMobile: '[data-nav-mobile]',
      navMobileBack: '[data-nav-mobile-back]',
      navMobileBody: '[data-nav-mobile-body]',
      navMobileBodyInner: '[data-nav-mobile-body-inner]',
      navMobileOverlay: '[data-nav-mobile-overlay]',
      linkWithDropdown: '[data-link-has-dropdown]',
      itemWithSubmenu: '[data-has-submenu]',
      itemWithNoSubmenu: '[data-no-submenu]',
      navMobileDropdown: '[data-nav-mobile-dropdown]',
      innerDropdown: '[data-nav-mobile-dropdown] details',
      menuItem: 'a[class$="__link"]',
    }
    this.classes = {
      headerNavOpen: 'is-nav-open',
      headerScrolled: 'is-scrolled',
      navMobileActive: 'is-visible',
      navMobileDropdownVisible: 'is-visible',
      navMobileButtonActive: 'is-active',
      navMobileDropdownExpanded: 'is-expanded',
      hidden: 'hidden',
    }

    this.lastScrollTop = 0;
    this.initSliderHandler = this.initSlider.bind(this);

    this.isMobile = window.innerWidth < 990;
    this.toggleSearchBar = this.toggleSearchBar.bind(this);
    this.inputKeyUp = this.inputKeyUp.bind(this);
    this.searchFieldClear = this.searchFieldClear.bind(this);

    this.searchTrigger = this.querySelector('.js-search-trigger');
    this.searchTriggers = document.querySelectorAll('.js-search-trigger');
    this.searchField = this.querySelector('.js-header-search-field');
    this.searchFieldClearButton = this.querySelector('.js-header-search-close');
    this.searchResultsHolder = this.querySelector('.js-header-search-results');
    this.aaArticles = this.querySelector('aa-dataset-articles');

    this.overlay = this.querySelector('.nav__overlay');

    this.htmlTag = document.getElementsByTagName("html")[0];
  }

  connectedCallback() {
    // Elements
    this.navMobileBody = this.querySelector(this.selectors.navMobileBody)
    this.navMobile = this.querySelector(this.selectors.navMobile)
    this.navMobileButton = this.querySelector(this.selectors.navMobileButton)
    this.navMobileButtonClose = this.querySelector(this.selectors.navMobileButtonClose)
    this.navMobileOverlay = this.querySelector(this.selectors.navMobileOverlay)
    this.navMobileBody = this.querySelector(this.selectors.navMobileBody)
    this.promoBarSlider = this.querySelector(this.selectors.promoBarSlider)
    this.menuItems = this.querySelectorAll(this.selectors.menuItem)

    // Handlers
    this.onScrollHandler = this.onScroll.bind(this)
    this.toggleMenuHandler = this.toggleMenu.bind(this)
    this.linkWithDropdownHandler = this.linkWithDropdownOnClick.bind(this)
    this.collapseMobileDropdownsHandler = this.collapseMobileDropdowns.bind(this)
    this.subMenuHandler = this.subMenuHandler.bind(this)
    this.checkDropdownVisibility = this.checkDropdownVisibility.bind(this)
    this.subMenuKeyHandler = this.subMenuKeyHandler.bind(this)
    this.clickEventDataLayer = this.clickEventDataLayer.bind(this);

    this.initSliderHandler();

    window.addEventListener('scroll', throttle((e) => { this.onScrollHandler() }, 400))
    window.addEventListener('load', this.onScrollHandler, false)

    this.navMobileButton.addEventListener(
      'click',
      this.toggleMenuHandler,
      false
    )
    this.navMobileOverlay.addEventListener(
      'click',
      (e) => {
        this.toggleMenuHandler(e, true)
      },
      false
    )
    this.navMobileButtonClose.addEventListener(
      'click',
      (e) => {
        this.toggleMenuHandler(e, true)
      },
      false
    )
    this.querySelectorAll(this.selectors.linkWithDropdown).forEach((link) => {
      link.addEventListener('click', this.linkWithDropdownHandler)
    })
    this.querySelectorAll(this.selectors.navMobileBack).forEach((button) => {
      button.addEventListener('click', this.collapseMobileDropdownsHandler)
    })
    this.querySelectorAll(this.selectors.innerDropdown).forEach((dropdown) => {
      dropdown.addEventListener('toggle', this.innerDropdownHandler)
    })
    this.querySelectorAll(this.selectors.itemWithSubmenu).forEach((item) => {
      item.addEventListener('click', this.subMenuHandler)
    })
    this.querySelectorAll(this.selectors.itemWithSubmenu).forEach((item) => {
      item.addEventListener('keyup', this.subMenuKeyHandler)
    })
    this.querySelectorAll(this.selectors.itemWithNoSubmenu).forEach((item) => {
      item.addEventListener('keyup', this.checkDropdownVisibility)
    })

    this.searchTrigger.addEventListener('click', this.toggleSearchBar);
    this.searchTriggers.forEach((trigger) => {
      trigger.addEventListener('click', this.toggleSearchBar);
    });
    // this.searchField.addEventListener('keyup', debounce(this.inputKeyUp, 200));
    // this.searchFieldClearButton.addEventListener(
    //   'click',
    //   this.toggleSearchBar
    // );

    document.addEventListener('click', (event) => {
      if (
        !(
          event.target.closest('.js-search-trigger') ||
          event.target.closest('.js-header-searchbar') ||
          event.target.closest('.js-search-again')
        )
      ) {
        this.closeSearchBar();
      }
    });

    this.querySelectorAll(this.selectors.menuItem).forEach((link) => {
      link.addEventListener('click', this.clickEventDataLayer)
    });

    this.aaArticles = this.querySelector(this.aaArticles);
    this.searchFieldClearButton.addEventListener('click', this.closeSearchBar());
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler)
  }

  initSlider() {
    const slider = this.promoBarSlider;

    if (!slider) {
      return
    }

    const splideSlider = new Splide(slider, {
      arrows: true,
      pagination: false,
      drag: true,
      rewind: true,
      autoplay: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      interval: slider.dataset.interval,
      lazyLoad: true,
    }).mount()

    this.querySelectorAll('.js-animation-button').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        const sliderAutoPlay = splideSlider.Components.Autoplay;
        if (sliderAutoPlay.isPaused()) {
          sliderAutoPlay.play();
        } else {
          sliderAutoPlay.pause();
        }
      })
    })

    splideSlider.on( 'autoplay:play', () => {
      this.querySelectorAll('.js-animation-button').forEach(button => {
        button.setAttribute('data-status', 'playing')
      })
    })

    splideSlider.on( 'autoplay:pause', () => {
      this.querySelectorAll('.js-animation-button').forEach(button => {
        button.setAttribute('data-status', 'pause')
      })
    })
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    if (scrollTop > this.lastScrollTop) {
      this.classList.add(this.classes.headerScrolled)
    }
    else {
      this.classList.remove(this.classes.headerScrolled)
    }
    this.lastScrollTop = scrollTop;
  }

  toggleMenu(e, close = false) {

    if (close) {
      this.navMobile.classList.remove(this.classes.navMobileActive)
      this.navMobileButton.classList.remove(this.classes.navMobileButtonActive)
      this.classList.remove(this.classes.headerNavOpen)

      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('width');
      window.scrollTo(0, scrollPosition);

      return
    }

    scrollPosition = window.pageYOffset;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';

    this.navMobile.classList.toggle(this.classes.navMobileActive)
    this.navMobileButton.classList.toggle(this.classes.navMobileButtonActive)
    this.classList.toggle(this.classes.headerNavOpen)
  }

  closeMenu() {
    this.navMobile.classList.remove(this.classes.navMobileActive)
    this.navMobileButton.classList.remove(this.classes.navMobileButtonActive)
    this.navMobileButton.classList.remove(this.classes.headerNavOpen)
    document.body.classList.remove('overflow-hidden')
    toggleBodyLock(this.navMobileBody, false)
    removeTrapFocus(this.navMobileButton)
  }

  linkWithDropdownOnClick(e) {
    e.preventDefault()
    const targetDropdown = document.querySelector(
      `${this.selectors.navMobileDropdown}[data-handle="${e.target.dataset.handle}"]`
    )

    if (!targetDropdown) {
      return
    }

    document
      .querySelectorAll(this.selectors.navMobileDropdown)
      .forEach((dropdown) => {
        dropdown.classList.remove(this.classes.navMobileDropdownVisible)
      })

    targetDropdown.classList.add(this.classes.navMobileDropdownVisible)

    document
      .querySelector(this.selectors.navMobileBodyInner)
      .classList.add(this.classes.navMobileDropdownExpanded)

    document
      .querySelector(this.selectors.navMobile)
      .classList.add(this.classes.navMobileDropdownExpanded)

    document
      .querySelector(this.selectors.navMobileBody)
      .classList.add(this.classes.navMobileDropdownExpanded)

    trapFocus(targetDropdown);
  }

  collapseMobileDropdowns(e) {
    e.preventDefault()

    document
      .querySelector(this.selectors.navMobileBodyInner)
      .classList.remove(this.classes.navMobileDropdownExpanded)

    document
      .querySelector(this.selectors.navMobileBody)
      .classList.remove(this.classes.navMobileDropdownExpanded)

    document
      .querySelector(this.selectors.navMobileBodyInner)
      .removeAttribute('style')

    document
      .querySelector(this.selectors.navMobile)
      .classList.remove(this.classes.navMobileDropdownExpanded)

    document
      .querySelectorAll(this.selectors.navMobileDropdown)
      .forEach((dropdown) => {
        dropdown.classList.remove(this.classes.navMobileDropdownVisible)
      })

    trapFocus(this.navMobile, e.target.closest('.nav-mobile__item').querySelector('.nav-mobile__link'))

  }

  checkDropdownVisibility(e) {
    if (e.keyCode == 9) {
      this.querySelectorAll(this.selectors.itemWithSubmenu).forEach((item) => {
        item.classList.remove('is-open');
        item.querySelector('a').setAttribute('aria-expanded', 'false');
      })
    }
  }

  subMenuKeyHandler(e) {
    e.preventDefault();
    const listItem = e.target;
    if (e.key == 'Tab' && e.target.classList.contains('nav__link')) {
      this.querySelectorAll(this.selectors.itemWithSubmenu).forEach((item) => {
        item.classList.remove('is-open');
        item.querySelector('a').setAttribute('aria-expanded', 'false');
      })
    }
  }

  subMenuHandler(e) {
    if (e.target.classList.contains('nav__link') && e.detail === 0) {
      e.preventDefault();
      const listItem = e.target.parentNode;
      if (listItem.hasAttribute('data-has-submenu')) {
        if (listItem.classList.contains('is-open')) {
          listItem.classList.remove('is-open');
          e.target.setAttribute('aria-expanded', 'false');
        } else {
          listItem.classList.add('is-open');
          e.target.setAttribute('aria-expanded', 'true');
        }
      }
    }
  }

  toggleSearchBar(e) {
    e.preventDefault();

    const searchBar = document.querySelector('.header__search');
    const clearButton = document.querySelector('.js-header-search-close');
    const navItems = document.querySelectorAll('.nav__item .nav__link__text');
    const headerSearchBtn = document.querySelector('.header__search-btn');

    navItems.forEach(trigger => {
      trigger.addEventListener('mouseover', () => {
        clearButton.classList.add('hidden');
        document.body.classList.remove('overflow-hidden');
        searchBar.classList.remove('is-visible');
        headerSearchBtn.classList.remove('is-active');
        headerSearchBtn.setAttribute('aria-expanded', 'false');
        headerSearchBtn.setAttribute('aria-pressed', 'false');
        searchBar.setAttribute('aria-expanded', 'false');
      });
    });

    if (!searchBar) return;

    searchBar.classList.add('is-visible');
    const isVisible = searchBar.classList.contains('is-visible');

    searchBar.setAttribute('aria-expanded', isVisible ? 'true' : 'false');
    headerSearchBtn.setAttribute('aria-expanded', isVisible ? 'true' : 'false');
    headerSearchBtn.setAttribute('aria-pressed', isVisible ? 'true' : 'false');
    this.searchTrigger.classList.add('is-active');

    document.body.classList.toggle('overflow-hidden', this.searchTrigger.classList.contains('is-active'));
    document.body.classList.toggle('full-height-with-overlay', this.searchTrigger.classList.contains('is-active'));

    this.searchFieldClear();

    waitForElm('.aa-product-info').then(() => trapFocus(searchBar));
  }

  closeSearchBar() {
    const searchBar = this.querySelector('.header__search');
    const headerSearchBtn = this.querySelector('.header__search-btn');

    if (!searchBar) {
      return;
    }

    document.body.classList.remove('overflow-hidden');
    searchBar.classList.remove('is-visible');

    searchBar.setAttribute('aria-expanded', 'false');
    headerSearchBtn.setAttribute('aria-expanded', 'false');
    headerSearchBtn.setAttribute('aria-pressed', 'false');
    this.searchTrigger.classList.remove('is-active');
    this.searchFieldClear();
    document.getElementById("header-search-form").reset();

    if (!document.body.classList.contains('template-cart') && document.querySelector('.mini-cart')) {
      if (!document.querySelector('.mini-cart').classList.contains('active')) {
        document.body.classList.remove('overflow');
        document.body.classList.remove('overflow-hidden');
        document.body.classList.remove('full-height-with-overlay');
        this.htmlTag.classList.remove('overflow');
        removeTrapFocus(searchBar);
      }
    }
    else {
      document.body.classList.remove('overflow');
      document.body.classList.remove('full-height-with-overlay');
      this.htmlTag.classList.remove('overflow');
    }

    if (this.overlay) {
      this.overlay.classList.remove('show');
    }
  }

  inputKeyUp(e) {
    const value = e.target.value;
    const viewAllButton = this.querySelector('.js-header-search-view-all');

    viewAllButton.classList.toggle('hidden', !value);
  }

  searchFieldClear(e) {
    if (e) {
      e.preventDefault();
    }

    this.searchField.focus();
    this.searchField.dispatchEvent(new Event('keyup'));
  }

  clickEventDataLayer (e) {
    const linkTitle = e.target.innerText;
    const linkUrl = e.target.href;

    window.ElevarPushToDataLayer({
      event: 'menu_click',
      link_text: linkTitle,
      link_destination: linkUrl
    });
  }
}

window.addEventListener("scroll", (event) => {
  let headerBarHeight = document.querySelector('.header-bar').offsetHeight + "px";
  let headerSection = document.querySelector("#shopify-section-header");
  let scroll = this.scrollY;

  scroll == 0 ? headerSection.style.top = "0" : headerSection.style.top = "-" + headerBarHeight;

});

window.addEventListener("load", (event) => {
  setTimeout( function() { checkSearchTemplate(); }, 500);
  function checkSearchTemplate() {
    if( document.body.classList.contains('template-search') && document.querySelector('.ais-stats--nb-results') ) {
      const countResults = document.querySelector('.ais-stats--nb-results').textContent;
      document.title = "Search:" + countResults;
    }
  }
})
let scrollPosition = 0;

function waitForElm(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}
customElements.define('sticky-header', StickyHeader)
